import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NatureGarantie } from "src/app/parametrage/core/model/garanties/nature-garantie";
import { NatureGarantieService } from "src/app/parametrage/core/service/nature-garantie.service";

@Component({
  selector: "app-add-garantie-to-dossier",
  templateUrl: "./add-garantie-to-dossier.component.html",
  styleUrls: ["./add-garantie-to-dossier.component.scss"],
})
export class AddGarantieToDossierComponent implements OnInit {
  @Input() array: FormArray;
  @Input() list: any;
  @Input() parentForm: FormGroup;
  @Input() formname: string;

  natureGaranties: NatureGarantie[];
  constructor(
    private fb: FormBuilder,
    private _natureGarantieService: NatureGarantieService
  ) {
    this.getAllNatureWithGarantieChamps();
  }

  ngOnInit() {
    this.prePopulate();
  }

  prePopulate() {
    if (this.list && this.list.length > 0) {
      this.list.forEach((val) => {
        this.array.push(this.addList(val));
      });
      console.log(this.parentForm.value);
      //this.parentForm.controls.formname = this.array;
    }
    //this.parentForm.controls.formname = this.array;
  }
  addList(val) {
    return this.fb.group(val);
  }
  get getGarantiesArrayForm(): FormArray {
    return this.parentForm.get("garantiesArrayForm") as FormArray;
  }
  getInitArrayFrom() {
    return this.fb.group({
      natureGarantieId: [null, Validators.compose([Validators.required])],
      descriptionGarantie: [null, Validators.compose([Validators.required])],
      montantGarantie: [null, Validators.compose([Validators.required])],
      dateEcheance: ["", Validators.compose([Validators.required])],
    });
  }

  addItem() {
    const itemForm = this.getInitArrayFrom();
    this.array.push(itemForm);
  }

  deleteItem(itemIndex: number) {
    this.array.removeAt(itemIndex);
  }
  getAllNatureWithGarantieChamps() {
    this._natureGarantieService
      .getAllNatureWithGarantieChamps()
      .subscribe((data) => {
        this.natureGaranties = data;
      });
  }
}
